import { Preferences } from '@capacitor/preferences';
import { isWeb } from './helpers';


export type localStorageReturnType = string | null


// instead of using localStorage, use Preferences for mobile apps
async function setPreferences (key: string, value: string){
  await Preferences.set({
    key: key,
    value: value
  })
}

async function getPreferences (key: string){
  const { value } = await Preferences.get({ key: key });
  return value;
}

async function removePreferences (key: string){
  await Preferences.remove({ key: key });
}

async function clearPreferences(){
  await Preferences.clear();
}

// ####################################

export async  function setStorageAllPlatforms(key: string, value: string) {
  if(isWeb){
    localStorage.setItem(key, value);
  }else{
    await setPreferences(key, value);
  }
}


export async  function getStorageAllPlatforms(key: string): Promise<localStorageReturnType> {
  if (isWeb) {
    return localStorage.getItem(key);
  } else {
    return await getPreferences(key)
  }
}



export async  function removeStorageAllPlatforms(key: string) {
  if(isWeb){
    localStorage.removeItem(key);
  }else{
    await removePreferences(key);
  }
}


export async function clearStorageAllPlatforms() {
  if(isWeb){
    localStorage.clear();
  }else{
    await clearPreferences();
  }
}